import { get, post, put, download } from './api.service'
import { CHALLENGE_SPACE_PHASES } from '../utils/constants'
import { remove } from 'lodash'

const service = {
	createChallengeSpace(params: any) {
		const reqParams = this.formatParams(params)
		return post('/challenge-spaces', reqParams)
	},

	formatParams(rawParams: any) {
		let params: any = rawParams
		if (!params.studentRankingEndDate) {
			params.studentRankingEndDate = null
		}
		if (!params.challengeRankingEndDate) {
			params.challengeRankingEndDate = null
		}
		return params
	},

	getPhases(space: any) {
		let phases = CHALLENGE_SPACE_PHASES.filter(
			(p) => p.value !== 'team_formation'
		)
		phases = space.attributes.useTeamFormation
			? phases.filter((p) => p.value !== 'challenge_submission')
			: phases.filter((p) => p.value !== 'challenge_submission_tf')

		if (!space.attributes.useChallenges) {
			phases = CHALLENGE_SPACE_PHASES.filter(
				(p) => p.value === 'team_formation'
			)
		}
		return phases
	},

	getActivePhase(space: any) {
		let currentState
		if (space.attributes.isStudentRankingActive) {
			currentState = CHALLENGE_SPACE_PHASES.filter(
				(phase) => phase.value === 'student_ranking'
			)[0]
		} else if (space.attributes.isChallengeRankingActive) {
			currentState = CHALLENGE_SPACE_PHASES.filter(
				(phase) => phase.value === 'challenge_ranking'
			)[0]
		} else if (space.attributes.distributionDone) {
			currentState = CHALLENGE_SPACE_PHASES.filter(
				(phase) => phase.value === 'evaluation'
			)[0]
		} else if (space.attributes.distributionStarted) {
			currentState = CHALLENGE_SPACE_PHASES.filter(
				(phase) => phase.value === 'matching'
			)[0]
		} else {
			if (!space.attributes.useChallenges) {
				currentState = CHALLENGE_SPACE_PHASES.filter(
					(phase) => phase.value === 'team_formation'
				)[0]
			} else {
				currentState = CHALLENGE_SPACE_PHASES.filter(
					(phase) =>
						phase.value ===
						(space.attributes.useTeamFormation
							? 'challenge_submission_tf'
							: 'challenge_submission')
				)[0]
			}
		}
		return currentState
	},

	getPublicChallengeSpaces(params: any) {
		return get('/challenge-spaces', params, { authenticate: false })
	},

	getChallengeSpaces(params: any) {
		return get('/challenge-spaces', params)
	},

	getUserChallengeSpaces(params: any) {
		return get('/challenge-spaces', params)
	},

	getUserChallengeSpace(spaceId: string) {
		return get(`/challenge-spaces/${spaceId}`)
	},

	getPublicChallengeSpace(spaceId: string) {
		return get(
			`/challenge-spaces/${spaceId}`,
			{ include: 'subject' },
			{
				authenticate: false,
			}
		)
	},

	updateChallengeSpaceState(challengeSpaceId: string, params: any) {
		return put(`/challenge-spaces/${challengeSpaceId}/state`, params)
	},

	createAccountChallengeSpace(params: any) {
		const reqParams = this.formatParams(params)
		return post('/challenge-spaces', reqParams)
	},

	updateUserChallengeSpace(spaceId: string, params: any) {
		const reqParams = this.formatParams(params)
		return put(`/challenge-spaces/${spaceId}`, reqParams)
	},

	setChallengeRecruitmentStatus(spaceId: string, params) {
		return put(`/challenge-spaces/${spaceId}/recruitment-state`, params)
	},

	setChallengeRankingStatus(spaceId: string, params) {
		return put(`/challenge-spaces/${spaceId}/ranking-state`, params)
	},

	setTeamRankingStatus(spaceId: string, params) {
		return put(`/challenge-spaces/${spaceId}/student-ranking-state`, params)
	},

	setStudentRegistrationState(spaceId: string, params: any) {
		return put(
			`/challenge-spaces/${spaceId}/student-registration-state`,
			params
		)
	},

	setEvaluationState(spaceId: string, params: any) {
		return put(`/challenge-spaces/${spaceId}/evaluation-state`, params)
	},

	setTeamRegistrationStatus(spaceId: string, params: any) {
		return put(`/challenge-spaces/${spaceId}/team-registration-state`, params)
	},

	getChallengeSpaceDistribution(spaceId: string) {
		return get(`/challenge-spaces/${spaceId}/distribution`)
	},

	getChallengeSpaceRankings(spaceId: string) {
		return get(`/challenge-spaces/${spaceId}/rankings`)
	},

	createTeam(spaceId: string, params: any, code?: string) {
		return post(
			`/challenge-spaces/${spaceId}/user-teams?code=${code}`,
			params,
			{ authenticate: false }
		)
	},

	getChallengeSpaceMailings(spaceId: string, params: any) {
		return get(`/challenge-spaces/${spaceId}/mailings`, params)
	},

	sendChallengeSpaceMailing(spaceId: string, params: any) {
		return post(`/challenge-spaces/${spaceId}/mailings`, params)
	},

	getChallengeSpaceExport(
		params: { challengeSpaceId: string },
		filetype: string
	) {
		return download(
			`/challenge-spaces/${params.challengeSpaceId}/export/${filetype}`,
			null,
			{
				authenticate: true,
				contentType: 'text/${filetype}',
			}
		)
	},

	getChallengeSpaceTeamsExport(
		params: { challengeSpaceId: string },
		filetype: string
	) {
		return download(
			`/challenge-spaces/${params.challengeSpaceId}/export/teams/${filetype}`,
			null,
			{
				authenticate: true,
				contentType: 'text/${filetype}',
			}
		)
	},

	getChallengeSpaceEvaluationExport(
		params: { challengeSpaceId: string },
		filetype: string
	) {
		return download(
			`/challenge-spaces/${params.challengeSpaceId}/export/evaluation/${filetype}`,
			null,
			{
				authenticate: true,
				contentType: 'text/${filetype}',
			}
		)
	},

	updateChallengeSpaceAdminUsers(spaceId: string, params: any) {
		return put(`/challenge-spaces/${spaceId}/admin-users`, params)
	},

	getChallengeSpaceNote(spaceId: string) {
		return get(`/challenge-spaces/${spaceId}/note`)
	},

	updateChallengeSpaceNote(spaceId: string, params: any) {
		return put(`/challenge-spaces/${spaceId}/note`, params)
	},

	updateChallengeSpaceTeamFormationState(
		spaceId: string,
		teamFormationId: string,
		params: any
	) {
		return put(
			`/challenge-spaces/${spaceId}/team-formations/${teamFormationId}/state`,
			params
		)
	},

	createChallengeSpaceTeamFormation(spaceId: string, params: any) {
		return post(`/challenge-spaces/${spaceId}/team-formations`, params)
	},

	// ADD ?include=distribution HERE TO SEND ONE REQUEST LESS
	getChallengeSpaceTeamFormation(spaceId: string, params?: any) {
		return get(`/challenge-spaces/${spaceId}/team-formation`, params)
	},

	updateChallengeSpaceTeamFormation(
		spaceId: string,
		teamFormationId: string,
		params: any
	) {
		return put(
			`/challenge-spaces/${spaceId}/team-formations/${teamFormationId}`,
			params
		)
	},

	removeChallengeSpaceTeamFormation(spaceId: string, teamFormationId) {
		return remove(
			`/challenge-space/${spaceId}/team-formations/${teamFormationId}`
		)
	},

	duplicateChallengeSpace(spaceId: string) {
		return put(`/challenge-spaces/${spaceId}/copy`, {})
	},

	isAllowedToCopyStudentRegistrationLink(space: any, teamFormation: any) {
		if (!space?.attributes || !teamFormation?.attributes) {
			return false
		}
		return (
			space.attributes.isStudentRegistrationActive &&
			space.attributes.uniqueCode &&
			space.attributes.state === 'active'
		)
	},
}

export const challengeSpaceHandler = {
	addChallengeEnabled(space, auth) {
		return (
			space &&
			space.attributes &&
			space.attributes.useChallenges &&
			!space.attributes.submissionExpired &&
			!space.attributes.isStudentRankingActive &&
			!space.attributes.isChallengeRankingActive &&
			!space.attributes.distributionStarted &&
			!space.attributes.distributionDone &&
			(auth.hasRole(['company-owner']) || auth.canManageSpace(space))
		)
	},
}

export default service
